import jQuery from 'jquery';

;(function ($, window, document, undefined) {

    var pluginName = "youtubeManager";
    var defaults = {
        playerSelector: ".zmp-yt-player", playerWidth: 640, playerHeight: 390, showDebug: false
    };

    function YoutubePlayer(manager, $obj) {
        this.manager = manager;
        this.$obj = $obj;
        this.$player;
        this.ytplayer;
        this.playerReady = false;

        this.init();
    }

    $.extend(YoutubePlayer.prototype, {
        init: function () {
            var _this = this;

            var width = _this.$obj.attr("data-width") || _this.manager.settings.playerWidth;
            var height = _this.$obj.attr("data-height") || _this.manager.settings.playerHeight;

            _this.$player = $("<div class=\"player\" />");
            _this.$obj.html(_this.$player);

            _this.ytplayer = new YT.Player(_this.$player.get(0), {
                height: height, width: width, videoId: '', events: {
                    'onReady': function (event) {
                        _this.onPlayerReady(_this, event);
                    }, 'onStateChange': function () {
                        _this.onPlayerStateChange(_this, event);
                    }
                }
            });

        }, onPlayerReady: function (_this, event) {
            var _this = this;
            _this.$obj.trigger("zmp_youtube_player_ready", [_this.ytplayer]);
            _this.load();
        }, onPlayerStateChange: function (_this, event) {
            /*if (event.data == YT.PlayerState.PLAYING && !done) {
              setTimeout(function(){
                stopVideo(event.target);
              }, 6000);
              done = true;
            }*/
            _this.$obj.trigger("zmp_youtube_playerstatechanged", [event, _this.ytplayer]);
        }, load: function () {
            var _this = this;
            var videourl = _this.$obj.attr("data-videourl");
            var videoid = _this.manager.getIdFromUrl(videourl);
            if (videoid != null) {
                _this.ytplayer.loadVideoById({
                    'videoId': videoid, 'startSeconds': 0, 'suggestedQuality': 'large'
                });
                _this.stop();
            }
            return videoid;
        }, stop: function () {
            var _this = this;
            _this.ytplayer.stopVideo();
        }
    });

    function YoutubePlayerManager(element, options) {
        var _this = this;
        this.element = element;
        this.$element = $(this.element);
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.apiReady = false;

        this.init();
    }

    $.extend(YoutubePlayerManager.prototype, {
        init: function () {
            var _this = this;

            _this.initYTApi();
        }, addPlayer: function ($target) {
            var _this = this;
            var ytp = new YoutubePlayer(_this, $target);
        }, initYTApi: function () {
            var _this = this;

            _this.initYTApiEvent();

            var tag = document.createElement('script');
            tag.src = "https://nl.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

        }, initYTApiEvent: function (funct) {
            var _this = this;

            onYouTubeIframeAPIReady = function () {
                _this.$element.trigger('zmp-yt-apiready');
                _this.apiReady = true;
            }

        }, getIdFromUrl: function (url) {
            var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url.match(regExp);
            if (match && match[2].length == 11) {
                return match[2];
            } else {
                return null;
            }
        }, reinit: function () {
            var _this = this;
            _this.renderPlayers();
        }, destroy: function () {
            this.$element.empty();
            this.$element.data("plugin_" + pluginName, null);
            //delete this;
        }, logmessage: function (message) {
            if (this.settings.showDebug) console.log(message);
        }
    });

    $.fn[pluginName] = function (methodOrOptions) {

        var method = (typeof methodOrOptions === 'string') ? methodOrOptions : undefined;

        if (method) {
            var customPlugins: Array<any> = [];

             const getCustomPlugin = () => {
                var $el = $(this);
                var customPlugin = $el.data("plugin_" + pluginName);

                customPlugins.push(customPlugin);
            }

            this.each(getCustomPlugin);

            var args = (arguments.length > 1) ? Array.prototype.slice.call(arguments, 1) : undefined;
            var results: Array<any> = [];

            const applyMethod = (index) => {
                var customPlugin = customPlugins[index];

                if (!customPlugin) {
                    console.warn('$.customPlugin not instantiated yet');
                    console.info(this);
                    results.push(undefined);
                    return;
                }

                if (method && typeof customPlugin[method] === 'function') {
                    var result = customPlugin[method].apply(customPlugin, args);
                    results.push(result);
                } else {
                    console.warn('Method \'' + method + '\' not defined in $.customPlugin');
                }
            }

            this.each(applyMethod);

            return (results.length > 1) ? results : results[0];
        } else {
            var options = (typeof methodOrOptions === 'object') ? methodOrOptions : undefined;

            const init = () => {
                var $el = $(this);
                var customPlugin = new YoutubePlayerManager($el, options);

                $el.data("plugin_" + pluginName, customPlugin);
            }

            return this.each(init);
        }


    };

})(jQuery, window, document);
